<template>
  <v-app :dark="false">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
    <notifications group="foo" />
    <div class="swipe-menu" v-hammer:swipe.left="toggleSidebar"></div>
  </v-app>
</template>

<script>
import store from "@/store";

export default {
  sockets: {
    message(ev) {
      sessionStorage.setItem("sid", ev);
    },
    acesso_realtec_received(payload) {
      store.dispatch("setAcessoRealtecDataNew", payload);
    },
    acesso_realtec_autorizado_negado(payload) {
      store.dispatch("setAcessoRealtecAutorizaNegaData", payload);
    },
    acesso_realtec_encerrado(payload) {
      store.dispatch("setAcessoRealtecEncerradoData", payload);
    }
  },
  data() {
    return {};
  },
  created() {
    this.ajustZoom();
    var user = JSON.parse(localStorage.getItem("user"));
    if (user) store.dispatch("setUserData", user);
  },
  mounted() {
    store.dispatch("setWindowHeight", window.innerHeight);
  },
  methods: {
    ajustZoom() {
      var h = window.screen.availHeight;
      var w = window.screen.availWidth;
      if (w <= 1370) {
        var _iOSDevice = !!navigator.platform.match(/iPhone|iPod|iPad/);
        if (_iOSDevice) {
          var vueInstance = document.getElementById("html");
          vueInstance.style.zoom = 0.8;
        } else {
          var vueInstance = document.getElementById("html");
          vueInstance.style.zoom = 0.7;
        }
      } else {
        var vueInstance = document.getElementById("html");
        vueInstance.style.zoom = 1;
      }
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    }
  }
};
</script>
<style>
.v-datatable thead th.column.sortable {
  cursor: pointer;
  outline: 0;
  font-size: 0.9rem;
}

table.v-table tbody td {
  font-weight: 400;
  font-size: 0.9em;
}
.tittle {
  font-size: 1.2rem !important;
  margin: 3px;
  font-weight: 500;
  line-height: 1 !important;
  letter-spacing: 0.02em !important;
  font-family: Roboto, sans-serif !important;
}
.md-checked .md-switch-thumb {
  background-color: #2a5377 !important;
}
.md-checked .md-switch-container {
  background-color: #ccb28e !important;
}
.swipe-menu {
  height: 100%;
  width: 36px;
  top: 0px;
  right: 0px;
  z-index: 500;
  background: transparent;
  position: absolute;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s;
}

.fade-enter,
  .fade-leave-to
    /* .fade-leave-active in <2.1.8 */

 {
  opacity: 0;
}

.md-snackbar {
  z-index: 500 !important;
}
::-webkit-scrollbar {
  width: 12px;

  background: rgba(255, 255, 255, 0.678) !important;
}

::-webkit-scrollbar-thumb {
  -webkit-border-radius: 10px;
  border-radius: 10px;
  background-color: #2a537788;
}
::-webkit-scrollbar-button {
  background: transparent !important;
}
::-webkit-scrollbar-track {
  background: transparent !important;
}
::-webkit-scrollbar-track-piece {
  background: transparent !important;
}
::-webkit-scrollbar-corner {
  background: transparent !important;
}

.app-flex {
  display: flex;
}

.app-row {
  flex-direction: row;
}

.app-col {
  flex-direction: column;
}

.app-full-width {
  width: 100%;
  height: auto;
}

.app-align-center {
  align-items: center;
}

.app-center {
  align-items: center;
  justify-content: center;
}

.app-end {
  align-items: flex-end;
  justify-content: flex-end;
}

.app-around {
  align-items: center;
  justify-content: space-around;
}

.app-text-center {
  text-align: center;
}

.app-text-initial {
  text-transform: initial;
}

.b-on {
  border-style: solid;
  border-width: 1px;
}

.b-red {
  border-color: red;
}

.b-green {
  border-color: green;
}

.b-blue {
  border-color: blue;
}

/* .v-menu__content {
    z-index: 8;
    margin-left: 0px;
    margin-top: 10px;
    color: #000;
    background: #000;
    background-color: #000;
    border: 1px solid #000;
}   */

/*.theme--light.v-list {
  background: black;
  background-color: #000;
}*/

div.custom-icon-rs {
  width: 60px;
  margin-left: 10px;
}

div.custom-icon-rs:hover {
  background-color: #f0f0f0;
}

.apexcharts-legend-series:hover {
  background-color: #d8d8d8
}

a.rltc-link {
  color: #2b5577 !important;
}

a.rltc-link:hover {
  color: #00aaff !important;
  text-decoration: underline !important;
}

</style>
